<template>
  <div>
    <van-tabs color="#1989fa" v-model="active">
      <van-form @submit="onSubmit">
        <van-field
          v-model="uservo.userName"
          rows="2"
         
          autosize
          label="客户姓名"
          type="textarea"
          placeholder="请输入客户姓名"
        />
        <van-field
          v-model="uservo.mobile"
          rows="2"
         
          autosize
          label="客户手机号:"
          :border="false"
          type="textarea"
          placeholder="请输入客户手机号"
          @change="getcode"
        />
        <van-field
          v-show="codeflag"
          rows="2"
          maxlength="6"
          
          v-model="code"
          :center="true"
          clearable
          label="验证码"
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button size="small" type="primary" @click.prevent="sendCode"
              >发送验证码</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="uservo.certNo"
          rows="2"
          
          autosize
          label="证件编号:"
          type="textarea"
          placeholder="请输入证件编号"
          :rules="[
            { required: true, message: '请填写身份证' },
            { validator, message: '身份证格式错误！' },
          ]"
        />
        <van-field
        rows="2"
        
          v-model="fieldValue"
          is-link
          readonly
          label="地区"
          placeholder="请选择所在地区"
          @click="show = true"
        />
        <van-popup v-model="show" round position="bottom">
          <van-cascader
            v-model="cascaderValue"
            title="请选择所在地区"
            :options="options"
            @close="show = false"
            @finish="onFinish"
            :field-names="fieldNames"
          />
        </van-popup>
        <!-- <div class="but-sty">
      <van-button type="primary" round block @click="login">登录</van-button>
    </div> -->
        <div class="login_bottom">
          <!-- <svg-icon icon-class="login_bottom" /> -->
          <van-checkbox
            v-model="checked"
            icon-size="15px"
            checked-color="#fc6e09"
            >提交即代表同意</van-checkbox
          >
          <p @click="checkProtocol">《服务协议》</p>
          <p @click="checkLicense">《信息授权协议》</p>
        </div>
        <van-popup
          v-model="showProtocol"
          :closeable="true"
          position="bottom"
          :style="{ height: '100%' }"
        >
          <div class="protocol-content">
            服务协议
            <service-agreement></service-agreement>
          </div>
        </van-popup>
        <van-popup
          v-model="showLicense"
          :closeable="true"
          position="bottom"
          :style="{ height: '100%' }"
        >
          <div class="protocol-content">
            授权协议
            <license-agreement></license-agreement>
          </div>
        </van-popup>
        <div style="margin: 16px">
          <van-button round block type="info" native-type="submit"
            >提交
          </van-button>
        </div>
      </van-form>
    </van-tabs>
  </div>
</template>
<script>
import URL from "@/api/api";
import { Toast } from "vant";
import { UrlSearch, setSession, setLocal } from "@/utils/utils";
import serviceAgreement from "@/view/login/serviceAgreement.vue";
import LicenseAgreement from "@/view/login/licenseAgreement.vue";
export default {
  components: { serviceAgreement, LicenseAgreement },
  data() {
    return {
      codeflag: false,
      code: "",
      fieldValue: "",
      show: false,
      cascaderValue: "",
      isDisabled: false,
      active: "",
      question: "",
      pid: 0,
      cid: "",
      content: "",
      checked: false,
      showProtocol: false,
      showLicense: false,
      options: [],
      fieldNames: {
        text: "name",
        value: "code",
        children: "child",
      },
      uservo: {
        userId: "",

        userName: "",
        mobile: localStorage.getItem("phoneNoC")
          ? localStorage.getItem("phoneNoC")
          : localStorage.getItem("phone"),
        certType: "1",
        certNo: "",
        province: "",
        city: "",
        type: "1",
      },
      message: "",
      productList: [],
      fileList: [],
      returnFileList: [],
      orderNo: this.$route.query.orderNo,
      status: "0",
      nickName: "",
    };
  },
  mounted() {
    this.getProductTypeAndProduct();
    // this.uservo.userId = UrlSearch().biztag;
    this.$nextTick(() => {
      if (this.orderNo) {
        this.orderDetails();
      }
    });
  },
  methods: {
    getcode() {
      this.codeflag = true;
    },
    validator(val) {
      const card15 =
        /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/;
      const card18 =
        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      return card15.test(val) || card18.test(val);
    },
    sendCode() {
      let data = {
        type: 5,
        phoneNumber: this.uservo.mobile,
      };
      let phoneNo = /^1[3456789]\d{9}$/;
      if (!phoneNo.test(this.uservo.mobile)) {
        Toast("请输入正确手机号");
      } else {
        this.$fetchGet(URL.sendCode.url, data).then((res) => {
          if (!this.timer) {
            // if(this.tips==0 && this.isFirst==0){
            //     setTimeout(() => {
            //         this.tips=1
            //     }, 7000);
            // }else{
            //     Toast('验证码5分钟之内有效')
            // }
            this.count = 60;
            this.timer = setInterval(() => {
              if (this.count >= 0 && this.count <= 60) {
                this.message = this.count-- + " " + "s";
              } else {
                this.message = "获取";
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        });
      }
    },
    checkProtocol() {
      this.showProtocol = true;
    },
    checkLicense() {
      this.showLicense = true;
    },
    orderDetails() {
      let data = {
        orderNo: this.orderNo,
        openid: localStorage.getItem("openid"),
      };
      this.$fetchGet(URL.orderDetails.url, data).then((res) => {
        this.pid = res.data.data.pid;
        this.cid = res.data.data.cid;
        this.message = res.data.data.tips;
        this.active = res.data.data.typeId;
        this.content = res.data.data.content;
        this.status = res.data.data.status;
        if (res.data.data.img) {
          let imgStr = JSON.stringify(res.data.data.img);
          let jsonb = imgStr.replace(
            /\/skjy\//g,
            // this.commonUrl.F_URL + "skjy/"
            process.env.VUE_APP_BASE_URL + "skjy/"
          );
          this.fileList = JSON.parse(jsonb);
        }
        if (this.status === "0" || this.status === "1") {
          this.isDisabled = true;
        }
      });
    },
    getProductTypeAndProduct() {
      this.$fetchGet(URL.getregion.url).then((res) => {
        this.options = res.data;
      });
    },

    onFinish({ selectedOptions }) {
      console.log(selectedOptions);
      if (selectedOptions.length > 1) {
        this.uservo.province = selectedOptions[0].code.substr(0, 2);
        this.uservo.city = selectedOptions[1].code;
      } else {
        this.uservo.province = selectedOptions[0].code.substr(0, 2);
        this.uservo.city = selectedOptions[0].code;
      }

      this.show = false;
      this.fieldValue = selectedOptions.map((option) => option.name).join("/");
    },

    beforeDelete(file, fileList) {
      this.fileList.splice(fileList.index, 1);
      let imgId = this.returnFileList.splice(fileList.index, 1);
      this.$fetchGet(URL.removeFile.url, { fileId: Number(imgId) }).then(
        (res) => {
          console.log(res.data.msg);
        }
      );
    },

    onSubmit(values) {
      if (this.uservo.userName == "") {
        Toast("请输入姓名");
      } else if (this.uservo.city == "") {
        Toast("请输入城市");
      } else if (!this.checked) {
        Toast("请勾选下方协议");
      } else if (this.codeflag && this.code == "") {
        Toast("请输入手机验证码");
      } else {
        let data = {
          id:localStorage.getItem("UserIdC"),
          idNo: this.uservo.certNo,
          phone:this.uservo.mobile,
          username: this.uservo.userName,
          channelCode:"luagent",
          cityCode:this.uservo.city,
          provinceCode:this.uservo.province,
          userPhone:UrlSearch().biztag,
          productCode:UrlSearch().postcode
        };
        let data1={
            openid: "11111",
        phoneNo: this.uservo.mobile,
        verifyCode: this.code,
        }
        this.$fetchPost(URL.lusaveBy.url, data).then((res) => {
          if (res.data.code == 20000) {
            this.$fetchPost(URL.login1.url, data1).then((res) => {
              if (!this.codeflag||res.data.code == 20000) {
                this.$fetchGet(URL.luupdateuse.url, {
                  phone: UrlSearch().biztag,
                }).then((res) => {});

                this.$fetchPost(URL.lufax.url, this.uservo).then((res) => {
                  if (res.data.code == 20000) {
                    let tocken = res.data.data;
                    let redirectUrl =
                      "http://ljt.luagent.com/loanStepTwo/" +
                      UrlSearch().postcode +
                      "?LJTfrom=POSTER&params=" +
                      JSON.stringify({ bizKey: UrlSearch().biztag });
                    redirectUrl = window.encodeURIComponent(redirectUrl);
                    let url =
                      "http://ljt.luagent.com/customerJointLogin?token=" +
                      tocken +
                      "&redirectUrl=" +
                      redirectUrl;

                    console.log("url++++++++" + url);
                    window.location.href = url;
                  }
                });
              }else if(res.data.code != 20000){
                Toast(res.data.msg);
              }
            });
          }else{
            Toast(res.data.msg);
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.van-tab__pane {
  width: 95%;
  margin: 10px auto;
}

.van-card__title {
  max-height: 32px;
  font-weight: 600;
  line-height: 40px;
  font-size: 16px;
}
.but-sty >>> .van-button--primary {
  width: 257px;
  height: 35px;
  margin: 81.5px auto 0;
}
.login_bottom {
  height: 15.5px;
  line-height: 15.5px;
  display: flex;
  font-size: 12px;
  margin: 84.5px auto auto 50px;
  /deep/.van-checkbox__icon {
    height: 15.5px;
    line-height: 15.5px;
  }
}
.dropdown-sty {
  width: 100%;
  display: flex;
  background: #fff;
}

.pro-tit {
  line-height: 50px;
  padding-left: 10px;
  font-size: 16px;
}

.van-dropdown-menu {
  /* width: 70%; */
}
.protocol-content {
  font-size: 20px;
  margin-top: 35px;
  text-align: center;
}
.pro-sty >>> .van-dropdown-menu__bar {
  align-items: start;
  background-color: transparent;
  box-shadow: none;
}

.van-dropdown-menu__bar {
}
</style>
